/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Strategy_Partner_Bitwise_LocationInputs */

const en_strategy_partner_bitwise_location = /** @type {(inputs: Strategy_Partner_Bitwise_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`San Francisco, CA`)
};

const de_strategy_partner_bitwise_location = /** @type {(inputs: Strategy_Partner_Bitwise_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`San Francisco, Kalifornien`)
};

const pt_br2_strategy_partner_bitwise_location = /** @type {(inputs: Strategy_Partner_Bitwise_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`São Francisco, CA`)
};

const tr_strategy_partner_bitwise_location = /** @type {(inputs: Strategy_Partner_Bitwise_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`San Francisco, Kaliforniya`)
};

const zh_cn2_strategy_partner_bitwise_location = /** @type {(inputs: Strategy_Partner_Bitwise_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加利福尼亚州旧金山`)
};

const zh_hk2_strategy_partner_bitwise_location = /** @type {(inputs: Strategy_Partner_Bitwise_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加州三藩市`)
};

const ko_kr2_strategy_partner_bitwise_location = /** @type {(inputs: Strategy_Partner_Bitwise_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`캘리포니아주 샌프란시스코`)
};

const ru_ru2_strategy_partner_bitwise_location = /** @type {(inputs: Strategy_Partner_Bitwise_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сан-Франциско, Калифорния`)
};

const es_419_strategy_partner_bitwise_location = /** @type {(inputs: Strategy_Partner_Bitwise_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`San Francisco, California`)
};

/**
* | output |
* | --- |
* | "San Francisco, CA" |
*
* @param {Strategy_Partner_Bitwise_LocationInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const strategy_partner_bitwise_location = /** @type {((inputs?: Strategy_Partner_Bitwise_LocationInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Strategy_Partner_Bitwise_LocationInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_strategy_partner_bitwise_location(inputs)
	if (locale === "de") return de_strategy_partner_bitwise_location(inputs)
	if (locale === "pt-BR") return pt_br2_strategy_partner_bitwise_location(inputs)
	if (locale === "tr") return tr_strategy_partner_bitwise_location(inputs)
	if (locale === "zh-CN") return zh_cn2_strategy_partner_bitwise_location(inputs)
	if (locale === "zh-HK") return zh_hk2_strategy_partner_bitwise_location(inputs)
	if (locale === "ko-KR") return ko_kr2_strategy_partner_bitwise_location(inputs)
	if (locale === "ru-RU") return ru_ru2_strategy_partner_bitwise_location(inputs)
	return es_419_strategy_partner_bitwise_location(inputs)
});